module.exports = __webpack_public_path__ + "static/media/logo_lenovo.a26ffa8e.png";